import { systemColors } from "../system";

export const ringColor = {
  focus: {
    primary: systemColors["sys-black"][100],
    secondary: systemColors["sys-chartreuse"][25],
    destructive: systemColors["sys-coral"][100],
  },
  primary: systemColors["sys-chartreuse"][600],
  secondary: systemColors["sys-chartreuse"][25],
  destructive: systemColors["sys-coral"][100],
  inverse: systemColors["sys-transparent"],
  hover: systemColors["sys-opacity-dark"][90],
  pressed: systemColors["sys-opacity-dark"][95],
};
